/*
 *  Faq Template Scripts
 *    Scripts that are only meant to run on the Faq Template.
 *
 *  Version:
 *    1.0.0 - 2020/08/05
 */

import { Accordion } from './../objects/accordion/Accordion';
import * as ResponsiveSizes from './../settings/Responsive';

// Selectors
export const FAQ_TEMPLATE_CONTAINER = '[data-faq-template]';
export const FAQ_CATEGORY_SELECTOR = '[data-faq-category]';
export const FAQ_CATEGORY_HANDLE = 'data-category-handle';
export const FAQ_ACCORDION_SELECTOR = '[data-faq-accordion]';

export const CATEGORIES_CAROUSEL_CONTAINER_SELECTOR = '[data-faq-categories-carousel-container]';
export const CATEGORIES_CAROUSEL_SELECTOR = '[data-faq-categories-carousel]';

export const ARTICLES_CAROUSEL_CONTAINER_SELECTOR = '[data-faq-articles-carousel-container]';
export const ARTICLES_CAROUSEL_SELECTOR = '[data-faq-articles-carousel]';

export const CLASS_INITIALIZED = 'slick-initialized';
export const CLASS_VISIBLE = 'is-visible';

class FaqTemplate {
  constructor(container) {
    // Elements
    this.container = container;

    this.faqAccordions = this.container.find(FAQ_ACCORDION_SELECTOR);

    this.categoriesCarouselContainer = container.find(CATEGORIES_CAROUSEL_CONTAINER_SELECTOR);
    this.categoriesCarousel = container.find(CATEGORIES_CAROUSEL_SELECTOR);

    this.articlesCarousels = container.find(ARTICLES_CAROUSEL_SELECTOR);

    // Initialise accordions
    this.faqAccordions.each((i, e) => {
      new Accordion($(e));
    });

    // Initialise carousels
    // this.categoriesSlick = this.initCategoriesCarousel();
    // this.articlesCarousels.each((i, e) => {
    //   let self = $(e);
    //   let carouselContainer = self.parents(ARTICLES_CAROUSEL_CONTAINER_SELECTOR);
    //   this.initArticlesCarousel(self, carouselContainer);
    // });

    // Set active accordion on slide change
    // container.on('beforeChange', CATEGORIES_CAROUSEL_SELECTOR, (e, slick, currentSlide, nextSlide) => {
    //   this.updateProgress(slick, currentSlide, nextSlide);
    // });

    // Reinit slick based on window size
    // $(window).on('resize orientationchange', () => this.onResize());

    // On desktop click, set active accordion
    container.on('click', FAQ_CATEGORY_SELECTOR, e => this.setDesktopCategory(e));
  }

  // onResize() {
  //   this.checkCategoriesCarousel();
  //   this.checkArticlesCarousel();
  // }

  // checkCategoriesCarousel() {
  //   if(this.categoriesCarousel.hasClass(CLASS_INITIALIZED)) return;
  //   if($(window).width() > ResponsiveSizes.medium - 1) return;
  //   this.initCategoriesCarousel(this.categoriesCarousel);
  // }

  // checkArticlesCarousel() {
  //   this.articlesCarousels.each((i, e) => {
  //     if($(window).width() > ResponsiveSizes.medium - 1) return;

  //     let self = $(e);
  //     if(self.hasClass(CLASS_INITIALIZED)) return;
  //     let carouselContainer = self.parents(ARTICLES_CAROUSEL_CONTAINER_SELECTOR);

  //     this.initArticlesCarousel(self, carouselContainer);
  //   });
  // }

  // initCategoriesCarousel() {
  //   let slick = this.categoriesCarousel.slick({
  //     mobileFirst: true,
  //     swipeToSlide: true,
  //     cssEase: this.categoriesCarouselContainer.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
  //     touchThreshold: 200,
  //     infinite: this.categoriesCarouselContainer.data('infinite') === true ? true : false,
  //     autoplay: this.categoriesCarouselContainer.data('autoplay') == true,
  //     autoplaySpeed: (this.categoriesCarouselContainer.data('autoplay-speed') * 1000) || 5000,
  //     slidesToShow: 2,
  //     slidesToScroll: 2,
  //     dots: false,
  //     arrows: false,
  //     adaptiveHeight: true,
  //     focusOnSelect: true,
  //     responsive: [
  //       {
  //         breakpoint: ResponsiveSizes.small - 1,
  //         settings: { slidesToShow: 4 }
  //       },
  //       {
  //         breakpoint: ResponsiveSizes.medium - 1,
  //         settings: "unslick"
  //       }
  //     ]
  //   });

  //   return slick;
  // }

  // initArticlesCarousel(carouselElement, carouselContainer) {
  //   let slick = carouselElement.slick({
  //     mobileFirst: true,
  //     swipeToSlide: true,
  //     cssEase: carouselContainer.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
  //     touchThreshold: 200,
  //     infinite: carouselContainer.data('infinite') === true ? true : false,
  //     autoplay: carouselContainer.data('autoplay') == true,
  //     autoplaySpeed: (carouselContainer.data('autoplay-speed') * 1000) || 5000,
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     dots: false,
  //     arrows: false,
  //     adaptiveHeight: true,
  //     focusOnSelect: true,
  //     responsive: [
  //       {
  //         breakpoint: ResponsiveSizes.small - 1,
  //         settings: { slidesToShow: 2 }
  //       },
  //       {
  //         breakpoint: ResponsiveSizes.medium - 1,
  //         settings: "unslick"
  //       }
  //     ]
  //   });

  //   return slick;
  // }

  // updateProgress(slick, currentSlide, nextSlide) {
  //   let slideEl = this.container.find(`[data-slick-index="${nextSlide}"] ${FAQ_CATEGORY_SELECTOR}`);
  //   let categoryHandle = slideEl.attr('data-category-handle');

  //   // Set active accordion
  //   this.setRelatedActive(categoryHandle);
  // }

  setDesktopCategory(e) {
    if(!$(window).width() > ResponsiveSizes.medium - 1) return;

    let self = $(e.currentTarget);
    let categoryHandle = self.attr(FAQ_CATEGORY_HANDLE);

    // Remove current active class
    this.container.find(FAQ_CATEGORY_SELECTOR).removeClass('is-active');

    // Set new active category
    self.addClass('is-active');

    // Set active accordion
    this.setRelatedActive(categoryHandle);
  }

  setRelatedActive(categoryHandle) {
    // Return if we don't have the category handle
    if(!categoryHandle) return;

    this.container.find(FAQ_ACCORDION_SELECTOR).removeClass(CLASS_VISIBLE);
    this.container.find(`[data-faq-accordion="${categoryHandle}"]`).addClass(CLASS_VISIBLE);

    this.container.find(ARTICLES_CAROUSEL_CONTAINER_SELECTOR).removeClass(CLASS_VISIBLE);
    this.container.find(`[data-faq-articles="${categoryHandle}"]`).addClass(CLASS_VISIBLE);
    this.container.find(`[data-faq-articles="${categoryHandle}"] ${ARTICLES_CAROUSEL_SELECTOR}`).slick('resize');
    this.container.find(`[data-faq-articles="${categoryHandle}"] ${ARTICLES_CAROUSEL_SELECTOR}`).addClass(CLASS_VISIBLE);
  }
}

$(document).ready($(FAQ_TEMPLATE_CONTAINER).each((i, e) => new FaqTemplate($(e))));